var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-container",attrs:{"id":"services"}},[_c('div',{staticClass:"section-title"},[_vm._v("Servicios")]),_c('b-breadcrumb',{staticClass:"breadcrumb",attrs:{"items":_vm.breadcrumbs}}),_c('ListServices')],1)}
var staticRenderFns = []

export { render, staticRenderFns }